import { ICellRendererParams } from 'ag-grid-community';
import { TypeLabelModel } from '../../../models/grid.model';

interface IProps extends ICellRendererParams, TypeLabelModel {
}

export const TypeRenderer = (props: IProps) => {
    return (
        <span className={`d-flex color-grid-label-font ${props.ClassName}`} key={props.Id} onClick={props.onClick}>
            {!!props.Icon && <props.Icon className={"my-auto mr-1"} />}
            <span className='my-auto'>{props.Label}</span>
        </span>
    );
};
